import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=1c82515c"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports